import { FC, useState } from 'react'
import Image from 'next/image'
import { ShopifyImg } from '@types'
import { Button } from '@components/ui'
import s from './ProductGallery.module.css'

interface ProductGalleryProps {
  images: [ImgNode]
  productTitle: string
}

interface ImgNode {
  node: ShopifyImg
}

const ProductGallery: FC<ProductGalleryProps> = ({ images, productTitle }) => {
  const [activeImg, setActiveImg] = useState(images[0].node)

  return (
    <div className="flex flex-col md:items-start gap-4 md:flex-row md:gap-8">
      <div className="order-2 md:order-1">
        <ul className="flex md:flex-col gap-4 content-between overflow-x-auto overflow-y-hidden">
          {images.map((image: ImgNode) => (
            <li key={image.node.url} className="shrink-0">
              <Button variant="naked" className={s.imgMinified} onClick={() => setActiveImg(image.node)}>
                <Image
                  className="rounded-md"
                  src={image.node.url}
                  alt={image.node.altText || productTitle}
                  width="100px"
                  height="100px"
                />
              </Button>
            </li>
          ))}
        </ul>
      </div>
      <div className={s.largeImg}>
        <Image src={activeImg.url} alt={activeImg.altText || productTitle} layout="fill" objectFit="cover" objectPosition="center top"  />
      </div>
    </div>
  )
}

export default ProductGallery
